function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 11,
  fill: "transparent"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.0996 11.2246H7.90039C7.81635 11.2246 7.75098 11.29 7.75098 11.374V12.7561C7.75098 12.8402 7.81635 12.9055 7.90039 12.9055H11.0101V17.1172C11.0101 17.2013 11.0755 17.2666 11.1595 17.2666H12.8591C12.9432 17.2666 13.0086 17.2013 13.0086 17.1172V12.9055H16.1183C16.2023 12.9055 16.2677 12.8402 16.2677 12.7561V11.374C16.249 11.29 16.1837 11.2246 16.0996 11.2246Z",
  fill: "#080503"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12 9.26359C12.7004 9.26359 13.2607 8.69394 13.2607 8.00289C13.2607 7.3025 12.6911 6.74219 12 6.74219C11.2996 6.74219 10.7393 7.31184 10.7393 8.00289C10.7393 8.70328 11.2996 9.26359 12 9.26359Z",
  fill: "#080503"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M12 0C5.36965 0 0 5.36965 0 12C0 18.6304 5.36965 24 12 24C18.6304 24 24 18.6304 24 12C24 5.36965 18.6304 0 12 0ZM19.3588 19.3588C17.3883 21.3292 14.7735 22.4125 12 22.4125C9.22646 22.4125 6.60233 21.3292 4.64124 19.3588C2.67082 17.3977 1.58755 14.7829 1.58755 12C1.58755 9.21712 2.67082 6.60233 4.64124 4.64124C6.60233 2.67082 9.21712 1.58755 12 1.58755C14.7829 1.58755 17.3977 2.67082 19.3588 4.64124C21.3292 6.61167 22.4125 9.22646 22.4125 12C22.4125 14.7829 21.3292 17.3977 19.3588 19.3588Z",
  fill: "#080503"
});

const SvgTbtc = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "tbtc-icon",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTbtc, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/tbtc.c59d550f.svg";
export { ForwardRef as ReactComponent };